import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingBag, Phone, Menu as MenuIcon, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { restaurant } from "../mock/menuData";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/carte", label: "La Carte" },
  { to: "/carte", label: "Commander" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);
  const loc = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobile(false);
  }, [loc.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0c0c0c]/95 backdrop-blur border-b border-white/10 py-2" : "bg-gradient-to-b from-black/80 to-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-1 group">
          <span className="font-script text-3xl md:text-4xl text-white leading-none">M.</span>
          <span className="font-script text-3xl md:text-4xl text-pink leading-none group-hover:text-white transition-colors">Plaisir</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className="font-body font-semibold text-sm uppercase tracking-wide text-white/85 hover:text-pink transition-colors relative after:absolute after:left-0 after:-bottom-1 after:h-0.5 after:w-0 after:bg-pink hover:after:w-full after:transition-all"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${restaurant.phone.replace(/\s/g, "")}`}
            className="hidden lg:flex items-center gap-2 text-white/90 hover:text-gold transition-colors font-semibold text-sm"
          >
            <Phone size={16} /> {restaurant.phone}
          </a>
          <button
            onClick={() => setOpen(true)}
            className="relative bg-pink text-white rounded-full p-2.5 btn-shine"
            aria-label="Panier"
          >
            <ShoppingBag size={20} />
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-gold text-black text-xs font-bold rounded-full h-5 min-w-5 px-1 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button className="md:hidden text-white p-2" onClick={() => setMobile((v) => !v)} aria-label="Menu">
            {mobile ? <X size={24} /> : <MenuIcon size={24} />}
          </button>
        </div>
      </div>

      {mobile && (
        <div className="md:hidden bg-[#0c0c0c] border-t border-white/10 px-4 py-4 flex flex-col gap-3 animate-float-up">
          {links.map((l) => (
            <button
              key={l.label}
              onClick={() => navigate(l.to)}
              className="text-left font-body font-semibold uppercase tracking-wide text-white/85 hover:text-pink py-1"
            >
              {l.label}
            </button>
          ))}
          <a href={`tel:${restaurant.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-gold font-semibold pt-2">
            <Phone size={16} /> {restaurant.phone}
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
